import React from 'react'
import styled from 'styled-components'
import { colors, breakpoints, mixins } from '../css-variables'
import PageSectionFromBlocks from '../page-sections/PageSectionFromBlocks'
import PageSection from '../page-sections/PageSection'
import CardHandler from '../content-modules/CardHandler'
import EmbedBlock from './EmbedBlock'
import GravityForm from './GravityForm'
import AccordionNavigation from './AccordionNavigation'
import SpecialBlock from '../content-modules/SpecialBlock'
import FeaturedEvent from '../content-modules/FeaturedEvent'
import EventList from '../../utils/EventList'
import Block from './WordPressBlock'
import RecentNotes from '../page-sections/RecentNotes'
import FormErrorBoundary from '../FormErrorBoundary'
import { CoreGallery } from '../../blocks/CoreGallery'
import ImageSlider from './ImageSlider'
import { tripDateFilter } from '../../utils/tools'

const WordPressContentBlocks = ({ className, blocks, products, stagger }) => {
    // see if the product has event and/or post nodes

    const staggerBlocks = stagger
        ? blocks.map(block => {
              block.stagger = true
              return block
          })
        : blocks

    /**
     * this is a hack to see if we are not on the aggregate template... which sets 'stagger'...
     * which means that we are on the product template, which needs borderTop set to true
     */

    const forceBorderTop = !stagger

    let RenderedBlocks = []

    staggerBlocks.forEach(block => {
        const borderTop = block.originalContent.indexOf(' border-top') > 0
        const stagger = block.stagger

        switch (block.name) {
            case 'core/group':
                if (
                    block.innerBlocks &&
                    block.originalContent.indexOf(' page-section') > 0
                ) {
                    //console.log('page-section')
                    RenderedBlocks.push(
                        <PageSectionFromBlocks
                            key={block.order}
                            blocks={block.innerBlocks}
                            borderTop={borderTop}
                            stagger={stagger}
                            centered
                        />,
                    )
                }
                if (
                    block.innerBlocks &&
                    block.originalContent.indexOf(' gallery') > 0
                ) {
                    //console.log('gallery')
                    RenderedBlocks.push(
                        <PageSectionFromBlocks
                            key={block.order}
                            blocks={block.innerBlocks}
                            gallery
                            borderTop={borderTop}
                            stagger={stagger}
                        />,
                    )
                }
                if (
                    block.innerBlocks &&
                    block.originalContent.indexOf(' card-set') > 0
                ) {
                    //console.log('card-set')
                    RenderedBlocks.push(
                        <PageSectionFromBlocks
                            key={block.order}
                            blocks={block.innerBlocks}
                            cardset
                            borderTop={borderTop}
                            stagger={stagger}
                        />,
                    )
                }

                break
            case 'core/gallery':
                RenderedBlocks.push(
                    <ImageSlider
                        key={block.order}
                        images={new CoreGallery(block).images}
                    />,
                )
                break
            case 'core/freeform':
            case 'core/paragraph':
            case 'core/list':
            case 'core/heading':
            case 'core/table':
            case 'core/image':
            case 'core/html':
                // these should do nothing, since they are not in a PageSection group
                //return (<Block className={block.name.replace('/', '-')} block={block.originalContent} />)
                break
            case 'gravityforms/form':
                //console.log('form found')
                const shortcode =
                    block.isDynamic && block.dynamicContent !== ''
                        ? block.dynamicContent
                        : block.originalContent
                //console.log(shortcode)
                    let idStart = shortcode.indexOf('gform_wrapper_')
                    idStart += 14
                    let idEnd = shortcode.indexOf("\'", idStart)
                    //console.log(idEnd)
                    //console.log(idStart)
                    const formId = shortcode.substring(idStart, idEnd)
                    //console.log(formId)
                    return (
                        <FormErrorBoundary>
                            <GravityForm
                                className={block.name.replace('/', '-')}
                                id={formId}
                                key={block.order}
                            />
                        </FormErrorBoundary>
                    )
                break

            case 'core-embed/flickr':
                RenderedBlocks.push(
                    <EmbedBlock
                        key={block.order}
                        source={block.originalContent}
                        type="flickr"
                    />,
                )
                break
            case 'core-embed/vimeo':
                //console.log('vimeo')
                //console.log(block)
                //return <div>foo</div>//
                RenderedBlocks.push(
                    <PageSection borderTop={borderTop} stagger={stagger}>
                        <EmbedBlock
                            key={block.order}
                            source={block.originalContent}
                            type="vimeo"
                        />
                    </PageSection>,
                )
                break
            case 'core/separator':
                RenderedBlocks.push(
                    <div
                        key={block.order}
                        dangerouslySetInnerHTML={{
                            __html: block.originalContent,
                        }}
                    />,
                )
                break
            case 'acf/accordion-navigation':
                RenderedBlocks.push(
                    <AccordionNavigation
                        key={block.order}
                        className={block.name.replace('/', '-')}
                        block={block}
                    />,
                )
                break
            case 'acf/staff-search':
                RenderedBlocks.push(
                    <Block
                        key={block.order}
                        className={block.name.replace('/', '-')}
                        block={block}
                    />,
                )
                break
            case "acf/product-story-listing":
                if (products?.nodes) { // because this can be used on Aggregate Pages, we need to be able to loop through multiple products

                    let combinedPosts = []
                    // set heading & button text
                    const attributes = JSON.parse(block?.attributesJSON)
                    const heading = attributes?.data?.custom_heading || "WAA Stories"
                    const buttonText = attributes?.data?.custom_button_text || 'See More WAA Stories'

                    products.nodes.forEach((product) => {

                        const { posts } = product 

                        if (posts?.nodes) {
                            posts.nodes.forEach((postToShow)  => {
                                combinedPosts.push(postToShow)
                            })
                        }
                    })
                    const postFilter = products?.nodes.length === 1
                    ? `?pub=${products.nodes[0].slug}`
                    : ''
            
            
                let reducedPosts = combinedPosts.slice(0,8)
                
                

                const buttons = (reducedPosts.length > 2) 
                    ? [{
                        link: `/news/all/${postFilter}`,
                        text: buttonText
                    }]
                    : null
                RenderedBlocks.push(<PageSection key={block.order} id="post-listing" heading={heading} topBorder={forceBorderTop} stagger={stagger} buttons={buttons}><CardHandler items={reducedPosts} type="news" size="M" /></PageSection>)    
                }
                
                break
                case "acf/events-listing-section":
                    if (products?.nodes) { // because this can be used on Aggregate Pages, we need to be able to loop through multiple products
                        let combinedEvents = []
                        // set heading & button text
                        const attributes = JSON.parse(block?.attributesJSON)
                        const heading = attributes?.data?.custom_heading || "Upcoming Events"
                        const buttonText = attributes?.data?.custom_button_text || 'See More Events'
                        const featureEvents = attributes?.data?.show_only_feature_events // 0 or 1

                        products.nodes.forEach((product) => {

                            const { events } = product 

                            if (events?.nodes) { // get the events for the current product
                                events.nodes.forEach((eventToShow)  => {
                                    if(!combinedEvents.find(element => element.url === eventToShow.url)){ // eliminate duplicates
                                        if (featureEvents == 1) { // for a "featured product events" listing
                                            if (eventToShow?.featured) {
                                                combinedEvents.push(eventToShow)
                                            }
                                        } 
                                        else { // for a standard product events listing
                                            combinedEvents.push(eventToShow)
                                        }
                                    } 
                                })
                            }
                        })

                        /* sort the big list of events by start date */
                        combinedEvents.sort((a, b) => (a.startDate > b.startDate) ? 1 : -1)

                        const singleProduct = (products.nodes.length === 1)
                        const travel = ( singleProduct && products.nodes[0]?.slug === 'travel')
                        let linkPath = (travel) 
                            ? `/trips/all` 
                            : (singleProduct)
                                ? `/events/all?product=${products.nodes[0].slug}`
                                : `/events/all` // if there are multiple products, we can't currently filter by by product
                       
                        const filteredEvents = new EventList(combinedEvents, { sort: true })
                        /* reduce the list down to 10 events */
                        const reducedEvents = (travel) // if travel events, start 6 months from now
                        ? filteredEvents.events.filter(tripDateFilter).slice(0,9)
                        : filteredEvents.events.slice(0,9)

                        const buttons = (combinedEvents.length > 2) 
                        ? [{
                            link: linkPath,
                            text: buttonText 
                        }]
                        : null
                    
                        RenderedBlocks.push(<PageSection key={block.order} id="event-listing" heading={heading} topBorder={forceBorderTop} stagger={stagger} buttons={buttons}><CardHandler items={reducedEvents} size="M" type="event"/></PageSection>)
                    }
                break
            case 'acf/note-listing':
                const buttons = [
                    {
                        link: `/alumninote/all/`,
                        text: 'See All Alumni Notes',
                    },
                ]
                RenderedBlocks.push(
                    <PageSection
                        key={block.order}
                        id="post-listing"
                        heading="WAA Alumni Notes"
                        topBorder={forceBorderTop}
                        stagger={stagger}
                        buttons={buttons}>
                        <RecentNotes />
                    </PageSection>,
                )

                break

            case 'acf/special-block':
                RenderedBlocks.push(
                    <SpecialBlock key={block.order} block={block} />,
                )
                break
            case 'acf/featured-event-block':
                RenderedBlocks.push(
                    <FeaturedEvent key={block.order} block={block} />,
                )
                break
            default:
                //console.log('default')
                RenderedBlocks.push(
                    <PageSectionFromBlocks
                        key={block.order}
                        blocks={[block]}
                        heading="Default"
                        borderTop={borderTop}
                        stagger={stagger}
                    />,
                )
                break
        }
    })

    return <div className={className}>{RenderedBlocks}</div>
}

const StyledWordPressContentBlocks = styled(WordPressContentBlocks)`
    hr.wp-block-separator {
        ${mixins.separator}
    }
    .product-card {
        ${mixins.contentCardBase}
        ${mixins.contentCardSizes}
        min-height: unset !important;
        display: flex;
        flex-flow: column;
        .title {
            ${mixins.cardTitle}
        }

        .button {
            a {
                ${mixins.buttons};
            }
        }
        .button--alt {
            a {
                ${mixins.buttonAlt};
            }
        }

        .columnwrap {
            display: flex;
            flex-flow: column;
            justify-content: space-between;
            height: 100%;
        }

        .jumbo-contentwrap {
            display: flex;
            flex-flow: column;
            width: 100%;
            flex-grow: 1;
        }

        &--XXL50 {
            margin: 0 auto;
            .jumbo-img {
                display: none;
            }
            @media screen and ${breakpoints.tabletL} {
                width: 814px;
                flex-flow: row;
                border-top: 1px solid ${colors.cardBorder};
                .jumbo-img {
                    display: block;
                    width: 398px;
                }

                .jumbo-contentwrap {
                    .attachment-full {
                        display: none;
                    }
                    .columnwrap {
                        border-right: none;
                    }
                }
            }
            @media screen and ${breakpoints.laptopS} {
                width: 1080px;
                .columnwrap {
                    :nth-last-child(1) {
                        flex: 1 1 auto;
                    }
                }
                .jumbo-img {
                    width: 528px;
                }
            }
        }
    }
`

export default StyledWordPressContentBlocks
